var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCalenderPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99953 0.638889C6.60953 0.198495 5.97953 0.198495 5.58953 0.638889L0.999531 5.82198C0.609531 6.26237 0.609531 6.97378 0.999531 7.41417L5.58953 12.5973C5.97953 13.0377 6.60953 13.0377 6.99953 12.5973C7.38953 12.1569 7.38953 11.4455 6.99953 11.0051L3.11953 6.61243L6.99953 2.23108C7.38953 1.79069 7.37953 1.06799 6.99953 0.638889Z",
    fill: "#6C7680"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalenderPrev);
export default __webpack_public_path__ + "static/media/ic_calender_prev.4b557f6658a001e7af14f060ce06c468.svg";
export { ForwardRef as ReactComponent };